import Modal from 'components/Modals/presets/BasicModal';
import { useTranslation } from 'react-i18next';
import { Typography } from '@kizen/kds/Typography';

export const WarningModal = (props: any) => {
  const { t } = useTranslation();

  return (
    <Modal
      size="small"
      {...props}
      heading={t('Payment Attempt Failed')}
      buttonText={t('Billing Settings')}
      actionBtnColor="blue"
      defaultLeftBtnText={t('Close')}
    >
      <div className="pb-2">
        <Typography>
          {t(
            'Your last payment attempt failed. Update your billing settings to ensure uninterrupted service.'
          )}
        </Typography>
      </div>
    </Modal>
  );
};
